// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Palette generated by Material Palette - materialpalette.com/teal/blue */
/* TODO: update references in code to above values */
:root {
  --production-primary-color: #1c3557;
  --secondary-color: #65758f;
  --production-accent-color: #65758f;
  --alternating-row-color: #e6e9ed;
  --panel-header-color: #65758f;
}

/* primary color */
/* warning message / error */
/* hyperlinks */
/* button */
/* secondary color light */
/* secondary accent color */
/* borders */
/* text colors and weight */
/* light on dark */
/* dialog */
/* page header */
/* dark */
/* filter and menu */
/* grid */
/* panels */
/* light on dark */
/* search control (header) */
/* primary color */
/* expansion panel / card */
/* input controls */
/* Toolbar styles */
.app-toolbar {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.app-header {
  color: #ffffff;
  background-color: var(--production-primary-color);
}

.production .app-header {
  color: #ffffff;
  background-color: var(--production-primary-color);
}

.training-app-header {
  color: #ffffff;
  background-color: #995f7b;
}

.toolbar-spacer {
  flex: 1 1 auto;
}

.toolbar-section {
  display: flex;
  align-items: center;
}

.toolbar-title {
  font-size: 18px;
  font-weight: 500;
}

/* Sidenav Container */
.sidenav-container {
  height: calc(100vh - 64px);
  width: 100%;
}

/* Sidenav styles */
.app-sidenav {
  background-color: #f6f5f7 !important;
  width: 220px !important;
  transition: width 0.3s ease;
  z-index: 0 !important;
}

.app-sidenav.small {
  width: 56px !important;
}

/* Sidenav content */
.sidenav-content {
  padding-top: 60px !important;
}

.sidenav-main-content {
  overflow-x: hidden;
}

/* Navigation list items */
.nav-list-item {
  font-size: 16px !important;
  font-weight: 500 !important;
  border-top: 1px solid #ccc;
  cursor: pointer !important;
  height: 30px !important;
}

.production .nav-list-item {
  border-top: 1px solid #ccc;
}

.nav-list-item.selected {
  background-color: var(--production-accent-color);
}

.production .nav-list-item.selected {
  background-color: var(--production-accent-color);
}

.nav-icon {
  color: var(--production-primary-color);
}

.production .nav-icon {
  color: var(--production-primary-color);
}

.header-icon {
  color: #f6f5f7 !important;
}

.module-menu {
  overflow-y: auto;
  overflow-x: hidden;
}

/* child menu items */
.children {
  visibility: visible;
  font-size: 14px !important;
  font-weight: 400 !important;
  border-top: none !important;
  border-bottom: none !important;
}

.item-children {
  padding-left: 36px;
}

.children .subSelected {
  background-color: #e6e9ed !important;
}

.children-not-visible {
  visibility: hidden;
  display: none;
}

.children-visible {
  visibility: visible;
  display: inherit;
}

.children-icon {
  padding-top: 3px !important;
  padding-left: 5px !important;
  font-size: 15px !important;
  color: var(--production-primary-color);
}

.production .children-icon {
  color: var(--production-primary-color);
}

/* minimized menu */
.label-hidden {
  visibility: hidden;
}

.small {
  width: 56px !important;
  transition: width 2s;
}

/* main page */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

a.appMainLink, a.appMainLink:hover, a.appMainLink:active, a.appMainLink:visited {
  text-decoration: none;
}

/* Material icon fix */
mat-icon {
  -webkit-user-select: none;
          user-select: none;
}

.badge-count {
  margin-left: 50px !important;
  margin-top: 1px !important;
  color: #fff;
  background-color: #1c3557;
  display: inline-block;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
}

.mat-mdc-list-item-title {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/app/core/navigation/navigation.component.scss"],"names":[],"mappings":"AAAA,0EAAA;AAQA,oDAAA;AAMA;EACE,mCAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,6BAAA;ACXF;;AD6ByB,kBAAA;AAIzB,4BAAA;AAIA,eAAA;AAGA,WAAA;AAC0B,0BAAA;AACK,2BAAA;AAE/B,YAAA;AAGA,2BAAA;AAC8B,kBAAA;AAM9B,WAAA;AAIA,gBAAA;AAM8B,SAAA;AAE9B,oBAAA;AASA,SAAA;AASA,WAAA;AAQmC,kBAAA;AAInC,4BAAA;AAE+B,kBAAA;AAE/B,2BAAA;AAIA,mBAAA;AC9GA,mBAAA;AACA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;AA6BF;;AA1BA;EACE,cD8CmB;EC7CnB,iDDFc;AC+BhB;;AA1BA;EACE,cDyCmB;ECxCnB,iDDdyB;AC2C3B;;AA1BA;EACE,cDoCmB;ECnCnB,yBDUuB;ACmBzB;;AA1BA;EACE,cAAA;AA6BF;;AA1BA;EACE,aAAA;EACA,mBAAA;AA6BF;;AAzBA;EACE,eAAA;EACA,gBAAA;AA4BF;;AAzBA,sBAAA;AACA;EACE,0BAAA;EACA,WAAA;AA4BF;;AAzBA,mBAAA;AACA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;AA4BF;;AAzBA;EACE,sBAAA;AA4BF;;AAzBA,oBAAA;AACA;EACE,4BAAA;AA4BF;;AAzBA;EACE,kBAAA;AA4BF;;AAzBA,0BAAA;AACA;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,uBAAA;AA4BF;;AAzBA;EACE,0BAAA;AA4BF;;AAzBA;EACE,gDDtEa;ACkGf;;AAzBA;EACE,gDDjFwB;AC6G1B;;AAzBA;EACE,sCD/Ec;AC2GhB;;AAzBA;EACE,sCD1FyB;ACsH3B;;AAzBA;EACE,yBAAA;AA4BF;;AAzBA;EACE,gBAAA;EACA,kBAAA;AA4BF;;AAxBA,qBAAA;AACA;EACE,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;AA2BF;;AAxBA;EACE,kBAAA;AA2BF;;AAxBA;EACE,oCAAA;AA2BF;;AAxBA;EACE,kBAAA;EACA,aAAA;AA2BF;;AAxBA;EACE,mBAAA;EACA,gBAAA;AA2BF;;AAxBA;EACE,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,sCD/Hc;AC0JhB;;AAxBA;EACE,sCD1IyB;ACqK3B;;AAxBA,mBAAA;AACA;EACE,kBAAA;AA2BF;;AAxBA;EACE,sBAAA;EACA,oBAAA;AA2BF;;AAxBA,cAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AA2BF;;AAxBA;EACE,qBAAA;AA2BF;;AAxBA,sBAAA;AACA;EACE,yBAAA;UAAA,iBAAA;AA2BF;;AAxBA;EACE,4BAAA;EACA,0BAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA2BF;;AAxBA;EACE,0BAAA;AA2BF","sourcesContent":["/* Palette generated by Material Palette - materialpalette.com/teal/blue */\n\n$production-primary-color: var(--production-primary-color);\n$production-accent-color: var(--production-accent-color);\n$secondary-color: var(--secondary-color);\n$alternating-row-color: var(--alternating-row-color);\n$panel-header-color: var(--panel-header-color);\n\n/* TODO: update references in code to above values */\n$primary-color: var(--production-primary-color);\n$accent-color: var(--production-accent-color);\n$primary-color-light: #f6f5f7;\n$primary-color-dark: #00796b;\n\n:root{\n  --production-primary-color: #1c3557;\n  --secondary-color: #65758f;\n  --production-accent-color: #65758f;\n  --alternating-row-color: #e6e9ed;\n  --panel-header-color: #65758f;\n}\n\n// Primary red shades\n// Not in use\n// $red--production-primary-color: #931438;\n// $red--production-accent-color: #f1cddf;\n\n// primary blue shades\n//$production-primary-color: #1c3557; // rgb(28,53,87)   /// CF261 - Dynamic Themes\n//$production-accent-color: #c9d6e9;   /// CF261 - Dynamic Themes\n\n$training-primary-color: #995f7b;\n\n//$secondary-color: #65758f;   /// CF261 - Dynamic Themes\n$secondary-accent-color: #c9ccd1;\n$secondary-color-light: #e6e9ed;\n\n$divider-color: #401d5a; /* primary color */\n\n$cf-hover: rgba(#757575, 0.04);\n\n/* warning message / error */\n$warning-color: #ff0000;\n$warning-color-background: #ffadad;\n\n/* hyperlinks */\n$link-color: #0000ee;\n\n/* button */\n$disabled-color: #f6f5f7; /* secondary color light */\n$disabled-text-color: #c9ccd1; /* secondary accent color */\n\n/* borders */\n$border-color: #212121;\n\n/* text colors and weight */\n$primary-color-text: #ffffff; /* light on dark */\n$readonly-richtext-color: #fafafa;\n$primary-text-color: #212121;\n$secondary-text-color: #757575;\n$primary-text-weight: 400;\n\n/* dialog */\n$dialog-header-text-size: 16px;\n$dialog-header-text-weight: 600;\n\n/* page header */\n$header-height: 60px;\n$header-text-size: 16px;\n$header-text-weight: 700;\n$subheader-text-size: 16px;\n$subheader-text-weight: 600;\n$header-label-color: #000000; /* dark */\n\n/* filter and menu */\n$filter-width: 250px;\n$menu-width: 220px;\n$menu-padding-top: 60px;\n$menu-text-size: 16px;\n$menu-text-weight: 500;\n$menu-child-text-size: 14px;\n$menu-child-text-weight: 400;\n\n/* grid */\n//$alternating-row-color: #e6e9ed; /* secondary color light*/   /// CF261 - Dynamic Themes\n$row-height: 34px;\n$row-header-height: 34px;\n$row-header-text-size: 14px;\n$row-header-text-weight: 500;\n$row-header-text-size-small: 12px;\n$table-text-size-small: 12px;\n\n/* panels */\n//$panel-header-color: #65758f; /* secondary color */   /// CF261 - Dynamic Themes\n$panel-height: 40px;\n$panel-height-small: 20px;\n$panel-height-medium: 30px;\n$panel-header-text-size: 16px;\n$panel-header-text-weight-small: 200;\n$panel-header-text-weight: 500;\n$panel-header-text-color: #ffffff; /* light on dark */\n\n$audit-text-size: 12px;\n\n/* search control (header) */\n$search-text-size: 14px;\n$search-border-color: #401d5a; /* primary color */\n\n/* expansion panel / card */\n$min-card-width: 270px;\n$large-card-width: 540px;\n\n/* input controls */\n$large-input-width: 200px;\n$large-input-height: 78px;\n$large-input-height-disabled: 58px;\n$small-input-width: 160px;\n\n$input-field-padding: 0 5px 0 5px;\n$input-field-margin: 5px 0 0 20px;\n$input-field-margin-no-left: 5px 0 0 0;\n$input-text-weight: 400;\n$input-field-top: -20px;\n$input-text-size: 12px;\n\n$input-field-padding-small: 0 5px 0 5px;\n$input-field-margin-small: 5px 0 0 10px;\n\n$label-text-size: 12px;\n$label-text-weight: 500;\n\n$min-form-field-width: 200px;\n$mid-form-field-width: 250px;\n$grid-column-gap: 16px;\n","@import 'variables';\n\n/* Toolbar styles */\n.app-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.app-header {\n  color: $primary-color-text;\n  background-color: $primary-color;\n}\n\n.production .app-header {\n  color: $primary-color-text;\n  background-color: $production-primary-color;\n}\n\n.training-app-header {\n  color: $primary-color-text;\n  background-color: $training-primary-color;\n}\n\n.toolbar-spacer {\n  flex: 1 1 auto;\n}\n\n.toolbar-section {\n  display: flex;\n  align-items: center;\n  // gap: 8px;\n}\n\n.toolbar-title {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n/* Sidenav Container */\n.sidenav-container {\n  height: calc(100vh - 64px);\n  width: 100%;\n}\n\n/* Sidenav styles */\n.app-sidenav {\n  background-color: $primary-color-light !important;\n  width: $menu-width !important;\n  transition: width 0.3s ease;\n  z-index: 0 !important;\n}\n\n.app-sidenav.small {\n  width: 56px !important;\n}\n\n/* Sidenav content */\n.sidenav-content {\n  padding-top: $menu-padding-top !important;\n}\n\n.sidenav-main-content {\n  overflow-x: hidden;\n}\n\n/* Navigation list items */\n.nav-list-item {\n  font-size: $menu-text-size !important;\n  font-weight: $menu-text-weight !important;\n  border-top: 1px solid #ccc;\n  cursor: pointer !important;\n  height: 30px !important;\n}\n\n.production .nav-list-item {\n  border-top: 1px solid #ccc;\n}\n\n.nav-list-item.selected {\n  background-color: $accent-color;\n}\n\n.production .nav-list-item.selected {\n  background-color: $production-accent-color;\n}\n\n.nav-icon {\n  color: $primary-color;\n}\n\n.production .nav-icon {\n  color: $production-primary-color;\n}\n\n.header-icon {\n  color: $primary-color-light !important;\n}\n\n.module-menu {\n  overflow-y: auto;\n  overflow-x: hidden;\n  // height: calc(100vh - 100px); // (total vertical height) - (topbar height)\n}\n\n/* child menu items */\n.children {\n  visibility: visible;\n  font-size: $menu-child-text-size !important;\n  font-weight: $menu-child-text-weight !important;\n  border-top: none !important;\n  border-bottom: none !important;\n}\n\n.item-children {\n  padding-left: 36px;\n}\n\n.children .subSelected {\n  background-color: $secondary-color-light !important;\n}\n\n.children-not-visible {\n  visibility: hidden;\n  display: none;\n}\n\n.children-visible {\n  visibility: visible;\n  display: inherit;\n}\n\n.children-icon {\n  padding-top: 3px !important;\n  padding-left: 5px !important;\n  font-size: 15px !important;\n  color: $primary-color;\n}\n\n.production .children-icon {\n  color: $production-primary-color;\n}\n\n/* minimized menu */\n.label-hidden {\n  visibility: hidden;\n}\n\n.small {\n  width: 56px !important;\n  transition: width 2s;\n}\n\n/* main page */\n.app-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\na.appMainLink, a.appMainLink:hover, a.appMainLink:active, a.appMainLink:visited{\n  text-decoration: none;\n}\n\n/* Material icon fix */\nmat-icon {\n  user-select: none;\n}\n\n.badge-count {\n  margin-left: 50px !important;\n  margin-top: 1px !important;\n  color: #fff;\n  background-color: #1c3557;\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n  text-align: center;\n  border-radius: 50%;\n}\n\n.mat-mdc-list-item-title {\n  font-size: 12px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
